// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';

// 遅延読み込み設定
//
// ajax通信
function lazyLoadHTML(ajaxURL) {
  $.ajax({
    url: ajaxURL,
    beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      xhr.setRequestHeader('Accept', 'application/javascript');
    },
    type: 'GET',
    timeout: 5000,
  });
}

// swiper設定
//
// MV
if (document.querySelector('[data-role="top-mv-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let topMvSwiper = new Swiper('[data-role="top-mv-swiper"]', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1.2,
        spaceBetween: 24,
      },
    },
    speed: 1500,
    pagination: {
      el: "[data-role='top-mv-swiper-pagination']",
      clickable: true,
    },
  });
}
// 特集
let topFeatureSwiper;
let topFeatureSwiperStatus;
let isTopFeatureLoaded = false;

if (document.querySelector('[data-role="top-feature-swiper"]') !== null) {
  window.addEventListener('load', () => {
    $(window).scroll(() => {
      if (!isTopFeatureLoaded) {
        lazyLoadHTML( '/top_feature.js');
        isTopFeatureLoaded = true;
      }
    });
    if (window.innerWidth >= 1024) {
      topFeatureSwiperCreate();
      topFeatureSwiperStatus = true;
    } else {
      topFeatureSwiperStatus = false;
    }
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth < 1024 && topFeatureSwiperStatus) {
      topFeatureSwiper.destroy(false, true);
      topFeatureSwiperStatus = false;
    } else if (window.innerWidth >= 1024 && !topFeatureSwiperStatus) {
      topFeatureSwiperCreate();
      topFeatureSwiperStatus = true;
    }
  });
  const topFeatureSwiperCreate = () => {
    topFeatureSwiper = new Swiper('[data-role="top-feature-swiper"]', {
      slidesPerView: 1.6,
      spaceBetween: 40,
      allowTouchMove: false,
      loop: true,
      centerInsufficientSlides: true,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 750,
      navigation: {
        nextEl: '[data-role="top-feature-swiper-nav-next"]',
        prevEl: '[data-role="top-feature-swiper-nav-prev"]',
      },
    });
  };
}

// Event
const topEvent = document.querySelector('.top-event');
if (topEvent !== null) {

  let eventDefaultTemplateId;
  const eventSwitchBtns = topEvent.querySelectorAll('.top-event-nav__btn');
  const eventShowArea = document.getElementById('top-event-list');
  eventSwitchBtns.forEach((eventBtn) => {
    if (eventBtn.classList.contains('is-active')) {
      eventDefaultTemplateId = eventBtn.getAttribute('data-template');
    }
  });

  const eventDefaultTemplate = document.getElementById(eventDefaultTemplateId);
  const eventDefaultTemplateClone = eventDefaultTemplate.content.cloneNode(true);

  // 初期状態の設定
  eventShowArea.innerHTML = '';
  const eventInitialElement = document.createElement('div');
  eventInitialElement.appendChild(eventDefaultTemplateClone);
  eventShowArea.appendChild(eventInitialElement);

  // swiper初期関数
  const eventInitializeSwipers = (container) => {
    const eventSwiperContainers = container.querySelectorAll('[data-role="top-event-swiper"]');
    eventSwiperContainers.forEach((swiperContainer) => {
      new Swiper(swiperContainer.querySelector('.swiper'), {
        swiperPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
        allowTouchMove: false,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 32,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            speed: 750,
          },
        },
        navigation: {
          nextEl: swiperContainer.querySelector('[data-role="top-event-list-nav-next"]'),
          prevEl: swiperContainer.querySelector('[data-role="top-event-list-nav-prev"]'),
        },
      });
    });
  };

  // 初期状態の Swiper を初期化
  eventInitializeSwipers(eventInitialElement);

  // 要素切り替え
  const eventSwitchArea = document.querySelector('.top-event-nav');
  eventSwitchArea.addEventListener('click', (e) => {
    const eventSwitch = e.target;
    if (eventSwitch.hasAttribute('data-template')) {
      // 新しいテンプレートを表示する場合
      const eventActiveTemplate = eventSwitch.getAttribute('data-template');
      const eventShowTemplate = document.getElementById(eventActiveTemplate);
      const eventShowTemplateClone = eventShowTemplate.content.cloneNode(true);

      // ボタン切り替え
      eventSwitchBtns.forEach((btn) => {
        if (btn === eventSwitch) {
          btn.classList.add('is-active');
          btn.ariaSelected = true;
        } else {
          btn.classList.remove('is-active');
          btn.ariaSelected = false;
        }
      });

      // 中身切り替え
      eventShowArea.innerHTML = '';
      const eventNewElement = document.createElement('div');
      eventNewElement.appendChild(eventShowTemplateClone);
      eventShowArea.appendChild(eventNewElement);

      // 新しい要素内の Swiper を初期化
      eventInitializeSwipers(eventNewElement);
    }
  });
}

// Course
const topCourse = document.querySelector('.top-course');
if (topCourse !== null) {

  let defaultTemplateId = 'top-course-default';
  const courseSwitchBtns = topCourse.querySelectorAll('.top-course-nav__btn');
  const courseShowArea = document.getElementById('top-course-list');

  const defaultTemplate = document.getElementById(defaultTemplateId);
  const defaultTemplateClone = defaultTemplate.content.cloneNode(true);

  // 初期状態の設定
  courseShowArea.innerHTML = '';
  const initialElement = document.createElement('div');
  initialElement.appendChild(defaultTemplateClone);
  courseShowArea.appendChild(initialElement);

  // swiper初期関数
  const initializeSwipers = (container) => {
    const swiperContainers = container.querySelectorAll('[data-role="top-course-swiper"]');
    swiperContainers.forEach((swiperContainer) => {
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      const slidesPerView = window.innerWidth >= 1024 ? 4 : 1.6;
      const loopEnabled = slideCount > slidesPerView;

      const swiperOptions = {
        swiperPerView: slidesPerView,
        spaceBetween: 16,
        centeredSlides: true,
        loop: slideCount > slidesPerView,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 750,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 32,
            centeredSlides: false,
          },
        },
        navigation: {
          nextEl: swiperContainer.querySelector('[data-role="top-course-list-nav-next"]'),
          prevEl: swiperContainer.querySelector('[data-role="top-course-list-nav-prev"]'),
        },
        on: {
          init: function(){
            const prevBtn = swiperContainer.querySelector('[data-role="top-course-list-nav-prev"]');
            const nextBtn = swiperContainer.querySelector('[data-role="top-course-list-nav-next"]');

            if(!loopEnabled) {
              prevBtn.classList.add('is-disabled');
              nextBtn.classList.add('is-disabled');
            } else {
              prevBtn.classList.remove('is-disabled');
              nextBtn.classList.remove('is-disabled');
            }
          },
        },
      };

      new Swiper(swiperContainer, swiperOptions);
    });
  };

  // 初期状態の Swiper を初期化
  initializeSwipers(initialElement);

  // 要素切り替え
  const courseSwitchArea = document.querySelector('.top-course-nav');
  courseSwitchArea.addEventListener('click', (e) => {
    const courseSwitch = e.target;
    if (courseSwitch.hasAttribute('data-template')) {
      // すでにアクティブなボタンをクリックした場合
      if (courseSwitch.classList.contains('is-active')) {
        // `is-active` クラスを外す
        courseSwitch.classList.remove('is-active');
        courseSwitch.ariaSelected = false;

        // デフォルトのテンプレートを表示
        courseShowArea.innerHTML = '';
        const defaultTemplateClone = defaultTemplate.content.cloneNode(true);
        const defaultElement = document.createElement('div');
        defaultElement.appendChild(defaultTemplateClone);
        courseShowArea.appendChild(defaultElement);

        // デフォルトテンプレートの Swiper を初期化
        initializeSwipers(defaultElement);
      } else {
        // 新しいテンプレートを表示する場合
        const activeTemplate = courseSwitch.getAttribute('data-template');
        const showTemplate = document.getElementById(activeTemplate);
        const showTemplateClone = showTemplate.content.cloneNode(true);
        lazyLoadHTML( `/top_course/${activeTemplate}.js`)

        // ボタン切り替え
        courseSwitchBtns.forEach((btn) => {
          if (btn === courseSwitch) {
            btn.classList.add('is-active');
            btn.ariaSelected = true;
          } else {
            btn.classList.remove('is-active');
            btn.ariaSelected = false;
          }
        });

        // 中身切り替え
        courseShowArea.innerHTML = '';
        const newElement = document.createElement('div');
        newElement.appendChild(showTemplateClone);
        courseShowArea.appendChild(newElement);

        // 新しい要素内の Swiper を初期化
        initializeSwipers(newElement);
      }
    }
  });
}

// エリアガイド
const topArea = document.querySelector('.top-areaguide');
if (topArea !== null) {
  // 要素切り替え
  const areaSwitchArea = document.querySelector('.top-areaguide-nav');
  const areaShowArea = document.getElementById('top-areaguide-contents');
  const areaSwitchBtns = topArea.querySelectorAll('.top-areaguide-nav__btn');

  let activeSwiper = null; // 現在のSwiperインスタンスを保持

  areaSwitchArea.addEventListener('click', (e) => {
    const areaSwitch = e.target;
    if (areaSwitch.hasAttribute('data-template')) {
      // 新しいテンプレートを表示する場合
      const areaActiveTemplate = areaSwitch.getAttribute('data-template');
      const areaShowTemplate = document.getElementById(areaActiveTemplate);
      const areaShowTemplateClone = areaShowTemplate.content.cloneNode(true);

      // ボタン切り替え
      areaSwitchBtns.forEach((btn) => {
        if (btn === areaSwitch) {
          btn.classList.add('is-active');
          btn.ariaSelected = true;
        } else {
          btn.classList.remove('is-active');
          btn.ariaSelected = false;
        }
      });

      // 中身切り替え
      areaShowArea.innerHTML = '';
      const areaNewElement = document.createElement('div');
      areaNewElement.appendChild(areaShowTemplateClone);
      areaShowArea.appendChild(areaNewElement);

      // 既存の Swiper インスタンスがある場合は破棄
      if (activeSwiper) {
        activeSwiper.destroy(true, true);
      }

      // 新しい Swiper を初期化
      activeSwiper = areaInitializeSwipers(areaNewElement);
    }
  });

  let areaDefaultTemplateId;
  areaSwitchBtns.forEach((areaBtn) => {
    if (areaBtn.classList.contains('is-active')) {
      areaDefaultTemplateId = areaBtn.getAttribute('data-template');
    }
  });

  const areaDefaultTemplate = document.getElementById(areaDefaultTemplateId);
  const areaDefaultTemplateClone = areaDefaultTemplate.content.cloneNode(true);

  // 初期状態の設定
  areaShowArea.innerHTML = '';
  const areaInitialElement = document.createElement('div');
  areaInitialElement.appendChild(areaDefaultTemplateClone);
  areaShowArea.appendChild(areaInitialElement);

  // Swiper 初期化関数
  const areaInitializeSwipers = (container) => {
    const swiperContainers = container.querySelectorAll('.top-areaguide-list');

    let swiperInstances = []; // Swiper インスタンスを管理する配列

    swiperContainers.forEach((swiperContainer) => {
      // 既存の Swiper インスタンスがあれば破棄
      if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
      }

      const swiperOptions = {
        spaceBetween: 10,
        slidesPerView: 1,
        centeredSlides: true,
        pagination: {
          el: swiperContainer.querySelector("[data-role='top-areaguide-swiper-pagination']"),
          clickable: true,
        },
      };

      const swiper = new Swiper(swiperContainer, swiperOptions);
      swiperInstances.push(swiper);

      // ボタンをクリックすると対応するスライドへ移動
      const buttons = container.querySelectorAll(".areaguide-area-button__item");
      buttons.forEach((button) => {
        button.addEventListener("click", function () {
          const targetId = button.getAttribute("data-id");
          const slideIndex = findSlideIndexByDataId(targetId, swiperContainer);

          if (slideIndex !== -1) {
            swiper.slideTo(slideIndex);
          }
        });
      });

      // スライドの data-id に基づいてインデックスを取得する関数
      function findSlideIndexByDataId(targetId, swiperContainer) {
        const slides = swiperContainer.querySelectorAll(".swiper-slide");
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute("data-id") === targetId) {
            return i;
          }
        }
        return -1;
      }

      // Swiper のスライド変更時に `is-active` クラスを更新
      swiper.on("activeIndexChange", function () {
        let sliderActiveNum = swiper.activeIndex;

        // スライダー内の関連ボタンのみ取得
        const pins = container.querySelectorAll(".areaguide-area-button__item");
        pins.forEach((pin) => {
          if (pin.getAttribute("data-id") === swiper.slides[sliderActiveNum].getAttribute("data-id")) {
            pin.classList.add("is-active");
          } else {
            pin.classList.remove("is-active");
          }
        });

        // `.circle-path` も同様に is-active を更新
        const circlePaths = container.querySelectorAll(".circle-path");
        circlePaths.forEach((circle) => {
          if (circle.getAttribute("data-id") === swiper.slides[sliderActiveNum].getAttribute("data-id")) {
            circle.classList.add("is-active");
          } else {
            circle.classList.remove("is-active");
          }
        });
      });
    });

    return swiperInstances.length > 0 ? swiperInstances[0] : null;
  };

  // 初期状態の Swiper を初期化
  activeSwiper = areaInitializeSwipers(areaInitialElement);
}



// AI協調フィルタリング
let topRecommendSwiper;
let topRecommendSwiperStatus;
const topRecommendSwiperCreate = () => {
  topRecommendSwiper = new Swiper('[data-role="top-recommend-swiper"] .swiper', {
    slidesPerView: 3.2,
    spaceBetween: 32,
    allowTouchMove: false,
    speed: 750,
    navigation: {
      nextEl: '[data-role="top-recommend-list-nav-next"]',
      prevEl: '[data-role="top-recommend-list-nav-prev"]',
    },
  });
};
const aiRecommend = document.querySelector('#top-ai-recommend');
if (aiRecommend) {
  $.ajax({
    url: '/recommends',
    data: {
      recommend_type: 'user',
      data_id: 'top-ai-recommend',
      data_type: 'top',
    },
    beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    },
    type: 'GET',
    timeout: 5000,
    success(data) {
      if (window.innerWidth >= 1024) {
        topRecommendSwiperCreate();
        topRecommendSwiperStatus = true;
      } else {
        topRecommendSwiperStatus = false;
      }
    },
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth < 1024 && topRecommendSwiperStatus) {
      topRecommendSwiper.destroy(false, true);
      topRecommendSwiperStatus = false;
    } else if (window.innerWidth >= 1024 && !topRecommendSwiperStatus) {
      topRecommendSwiperCreate();
      topRecommendSwiperStatus = true;
    }
  });
}

// バナー
let topBannerSwiper;
let topBannerSwiperStatus;

if (document.querySelector('[data-role="top-banner-swiper"]') !== null) {
  window.addEventListener('load', () => {
    if (window.innerWidth >= 1024) {
      topBannerSwiperCreate();
      topBannerSwiperStatus = true;
    } else {
      topBannerSwiperStatus = false;
    }
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth < 1024 && topBannerSwiperStatus) {
      topBannerSwiper.destroy(false, true);
      topBannerSwiperStatus = false;
    } else if (window.innerWidth >= 1024 && !topBannerSwiperStatus) {
      topBannerSwiperCreate();
      topBannerSwiperStatus = true;
    }
  });
  const topBannerSwiperCreate = () => {
    topBannerSwiper = new Swiper('[data-role="top-banner-swiper"] .swiper', {
      slidesPerView: 5,
      spaceBetween: 16,
      allowTouchMove: false,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 750,
      navigation: {
        nextEl: '[data-role="top-banner-list-nav-next"]',
        prevEl: '[data-role="top-banner-list-nav-prev"]',
      },
    });
  };
}
